<template>
  <lm-modal
    :ref="modalName"
    :name="modalName"
    :type="modalType"
    class="ModalUpgradePlan"
    title="Upgrade your plan"
    remove-footer
    @click="onClick($event)"
  >
    <p class="text-gray-700">
      You are currently on a
      <span class="text-gray-900 uppercase">{{ plan.type }}</span> plan.
    </p>
    <template v-if="isFree">
      <p class="text-gray-700">
        Upgrade to <span class="text-gray-900">Premium</span> to unlock all your
        landscapes and users, create new ones and enjoy many more features.
      </p>
    </template>
    <template v-else-if="isTrial || isPremium">
      <p class="text-gray-700">
        Upgrade to <span class="text-gray-900">Business</span> to create
        unlimited landscapes, get more users and customize the experience to
        your specific needs.
      </p>
    </template>
    <span class="text-link cursor-pointer hover:underline" @click="goToPlans">
      View plans</span
    >
  </lm-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import LmModal from '@/components/ui/LmModal'
import EventHub from '@/lib/eventHub'
import {Events, Modal, ModalType} from '@/lib/definitions'

export default {
  name: 'ModalUpgradePlan',
  components: {
    LmModal
  },
  data() {
    return {
      modalName: Modal.UPGRADE_PLAN,
      modalType: ModalType.SUBMODAL
    }
  },
  computed: mapGetters(['plan', 'isFree', 'isTrial', 'isPremium']),
  methods: {
    goToPlans() {
      EventHub.emit(Events.CLOSE_SIDENAV)
      this.$router.push({name: 'subscription'})
    }
  }
}
</script>
